module.exports = __webpack_public_path__ + "static/img/infoQ.b57eed9a.webp";